import {useState} from 'react'
import {
  SimpleForm,
  TextInput,
  Create,
  Datagrid,
  List,
  TextField,
  SelectInput,
  Edit,
  SaveButton,
  Toolbar,
  TopToolbar,
  CreateButton,
  FilterButton,
  Button,
  useNotify,
} from 'react-admin'
import UserCSVImportInput from './comps/UserCSVImportInput'
import { vROrgId } from 'shared/dist/types/Organization'

// const ImportUsers: React.FC<{onCancelClick: () => void}> = ({
//   onCancelClick,
// }) => {
//   return (
//     <div>
//       <FileReaderInput onImportComplte={() => const notify = useNotify()}/>
//       <Button label="cancel" onClick={onCancelClick} />
//     </div>
//   )
// }

const OrgListActions: React.FC<{onImportUserClick: () => void}> = ({
  onImportUserClick,
}) => (
  <TopToolbar>
    <Button label="import users" onClick={onImportUserClick} />
    <CreateButton />
  </TopToolbar>
)

type FormState = 'list' | 'import-users'
export const OrgList: React.FC = () => {
  const [formState, setFormState] = useState<FormState>('list')
  const notify = useNotify()

  return (
    <List
      actions={
        <OrgListActions
          onImportUserClick={() => setFormState('import-users')}
        />
      }>
      {formState === 'list' ? (
        <Datagrid rowClick="edit">
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="maxUserCount" />
        </Datagrid>
      ) : (
        <div>
          <UserCSVImportInput
            onImportComplete={() => {
              setFormState('list')
              notify('users successfully imported')
            }}
            onCancelClick={() => setFormState('list')}
          />
        </div>
      )}
    </List>
  )
}

const orgToolbar = (
  <Toolbar>
    <SaveButton />
  </Toolbar>
)

export const OrgForm = () => (
  <SimpleForm maxWidth={700} toolbar={orgToolbar}>
    <TextInput source="name" required />
    <TextInput source="maxUserCount" required />
  </SimpleForm>
)

export const OrgEdit = () => {
  return (
    <Edit>
      <OrgForm />
    </Edit>
  )
}

export const OrgCreate = () => {
  return (
    <Create>
      <OrgForm />
    </Create>
  )
}
